import { render, staticRenderFns } from "./ProjectP4PPropUpdate.vue?vue&type=template&id=7c6f2904&"
import script from "./ProjectP4PPropUpdate.vue?vue&type=script&lang=js&"
export * from "./ProjectP4PPropUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports